module.exports = __webpack_public_path__ + "img/df6fe47.png";